import React, { createContext, useContext, useState } from "react";
import { Link } from "@mui/material";
import { SkipLinkConfig, SkipLinkProviderValue } from "./types";

const SkipLinkContext = createContext<SkipLinkProviderValue | null>(null);

export function SkipLinkProvider({ children }: { children: React.ReactNode }) {
    const [skipLinkConfig, setSkipLinkConfig] = useState<SkipLinkConfig | null>(
        null
    );

    return (
        <SkipLinkContext.Provider value={{ setSkipLink: setSkipLinkConfig, skipLinkConfig }}>
            {children}
        </SkipLinkContext.Provider>
    );
}

export const useSkipLink = () => {
    const context = useContext(SkipLinkContext);
    if (!context) {
        throw new Error("useSkipLink must be used within a SkipLinkProvider");
    }
    return context;
};

export function SkipLink() {
    const { skipLinkConfig } = useSkipLink();

    if (!skipLinkConfig) {
        return null;
    }

    return (
        <Link
            component="button"
            onClick={skipLinkConfig.onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    skipLinkConfig.onClick();
                }
            }}
            sx={{
                color: "#ffffff",
                textDecoration: "underline",
                cursor: "pointer",
                background: "rgba(0, 0, 0, 0.8)",
                border: "2px solid #ffffff",
                padding: "8px 16px",
                font: "inherit",
                fontSize: "14px",
                borderRadius: "4px",
                position: "fixed",
                top: "-100px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 99999999,
                outline: "2px solid #ffffff",
                outlineOffset: "2px",
                "&:focus-within": {
                    top: "10px",
                },
            }}
            tabIndex={0}
            aria-label={skipLinkConfig.title}
        >
            {skipLinkConfig.title}
        </Link>
    );
}
